import {
  Header,
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const StartDate = <Questionnaire extends QuestionnaireQuestions>({
  onSubmitValue,
  setValidForSubmission,
}: QuestionnaireFormProps<Questionnaire>) => {
  const [startDate, setStartDate] = useState<string | undefined>();

  const possibleStartDatesFromTodaysDate = () =>
    Array.from(Array(6).keys()).map((offset) =>
      dayjs()
        .add(offset + 1, 'month')
        .startOf('month')
        .format('YYYY-MM-DD')
    );

  useEffect(() => {
    if (!startDate) {
      setStartDate(possibleStartDatesFromTodaysDate()[0]);
    }
  }, [startDate, setStartDate]);

  useEffect(() => {
    setValidForSubmission(!!startDate);
  }, [startDate, setValidForSubmission]);

  return (
    <Header onSubmit={() => onSubmitValue(startDate)}>
      <select
        className="p-select w100 ws5 mt16"
        id="coverageStartDate"
        onChange={(e) => {
          setStartDate(e.target.value);
        }}
        value={startDate}
      >
        {possibleStartDatesFromTodaysDate().map((date) => (
          <option key={date} value={date}>
            {dayjs(date).format('D MMMM YYYY')}
          </option>
        ))}
      </select>
    </Header>
  );
};
